import { Button, Result } from "antd";
import React from "react";

type BulkUploadSuccessProps = {
  customerName?: string;
  message?: string;
  onBackToUpload: () => void;
};

const BulkUploadSuccess: React.FC<BulkUploadSuccessProps> = ({
  customerName,
  message,
  onBackToUpload,
}) => (
  <Result
    status="success"
    title={message || "Successfully completed the bulk upload process!"}
    subTitle={`The data for customer ${customerName} has been processed.`}
    extra={[
      <Button type="primary" key="upload" onClick={onBackToUpload}>
        Upload Another File
      </Button>,
    ]}
  />
);

export default BulkUploadSuccess;
